import React__default from 'react';
import { useIsMobile, TaktIdProvider, createStormTaktId, Flex, withTaktFallbackId } from '@amzn/storm-ui';
import { H as HMHConsistentIngressAnchor } from './HMHConsistentIngressAnchor/HMHConsistentIngressAnchor-DZdK9Bau.js';
import { F as FocusPageHeaderWrapper, a as FocusTitle, b as FocusCloseButton } from './FocusPageHeader.styles-DbQeBB4E.js';
import { A as ActionsContainer } from './actions/ActionsContainer-CVsVb72q.js';
import { g as getTranslationComponent } from '../i18n/PageHeaderTranslation/index-D-JlEl92.js';
import { H as HelpDropdown } from './HelpDropdown/HelpDropdown-DVWuGH0x.js';
import { u as useHelpInfo } from '../utils/useHelpInfo-DSBDDgvL.js';
import { u as useHMHScriptLoaded } from '../utils/useHasHMHScriptLoaded-CEqYoUYv.js';
import { I as IntlProvider } from '../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DmRs8GLp-yq9BpgTU.js';

const CloseButton = withTaktFallbackId(FocusCloseButton);
const FocusPageHeader = ({
  applicationName,
  onClose,
  title,
  renderPageTitleIcon,
  renderActions,
  actionsErrorMessage,
  taktId,
  taktValue,
  locale = 'en-US',
  ...props
}) => {
  const isMobile = useIsMobile();
  const helpInfo = useHelpInfo();
  // Determine whether the HelpMeHereAPI script has loaded
  const hasHMHScriptLoaded = useHMHScriptLoaded();
  return /*#__PURE__*/React__default.createElement(IntlProvider, {
    resetKey: locale,
    translations: getTranslationComponent(locale)
  }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('focus-page-header')
  }, /*#__PURE__*/React__default.createElement(FocusPageHeaderWrapper, props, /*#__PURE__*/React__default.createElement(Flex, null, /*#__PURE__*/React__default.createElement(CloseButton, {
    size: "base",
    onClick: onClose,
    taktFallbackId: createStormTaktId('focus-page-header-close-button'),
    "data-testid": "focus-page-header-close-button"
  }), title && /*#__PURE__*/React__default.createElement(FocusTitle, {
    renderAs: "h1",
    size: "small"
  }, title), renderPageTitleIcon === null || renderPageTitleIcon === void 0 ? void 0 : renderPageTitleIcon()), /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center"
  }, !isMobile && (!!renderActions || hasHMHScriptLoaded) && /*#__PURE__*/React__default.createElement(ActionsContainer, {
    errorMessage: actionsErrorMessage
  }, renderActions === null || renderActions === void 0 ? void 0 : renderActions(), hasHMHScriptLoaded && /*#__PURE__*/React__default.createElement(HMHConsistentIngressAnchor, {
    applicationName: applicationName
  })), isMobile && !!helpInfo && /*#__PURE__*/React__default.createElement(HelpDropdown, {
    helpInfo: helpInfo
  })))));
};

export { FocusPageHeader as F };
//# sourceMappingURL=FocusPageHeader--YQSPpUH.js.map
